<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">

    <div class="hpanel no-margins" >
      <template v-if="authors.length !== 0">

        <div class="panel-heading hbuilt">

          <div class="row">
            <div class="text-center" :class="nbSearchCompanies !== null ?'col-xs-4':'col-xs-6'">
              Best Experts: <span class="font-extra-bold m-t-xl m-b-xs text-info" >{{bestExperts}}</span>
            </div>
            <div class="text-center" :class="nbSearchCompanies !== null ?'col-xs-4':'col-xs-6'">
              Total Experts estimate: <span class="font-extra-bold m-t-xl m-b-xs" style="">{{nbEstimateExperts}}</span>
            </div>
            <div v-if="nbSearchCompanies !== null" class="col-xs-4 text-left">
              Companies: <span role="button" class="font-extra-bold m-t-xl m-b-xs " @click="launchCompanySearch()" title="Click to launch companies search "> {{nbSearchCompanies ? nbSearchCompanies: 'n.a.'}}</span>
            </div>

          </div>

        </div>

        <div class="panel-body no-padding ">
          <table style="width: 100%">
            <tr style="height: 25px">
              <th class="col-md-2 col-xs-2"><span role="button" @click="changeSort('expert')">Expert <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
              <th class="col-md-3 col-xs-3">
                <table class="table" style="width: 100%;">
                  <td class="col-xs-4 col-md-4 col-lg-4 text-center" style="vertical-align: middle">
                    <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                  <td class="col-xs-8 col-md-8 col-lg-8" style="vertical-align: middle">
                    <span role="button" @click="changeSort('affiliation')">Affiliation <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                </table>
              </th>
              <th class="col-md-4 col-xs-4"><span>Top document</span></th>
              <th class="col-md-1 col-xs-1 text-right"><span role="button" @click="changeSort('score')">Score <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
              <th class="col-md-1 col-xs-1"></th>
              <th class="col-md-1 col-xs-1 text-center"><span>Action</span></th>
            </tr>

          </table>
          <div v-if="authors.length !== 0" :set="nbItemsDisplayed = 0">

            <div v-for="(author, key) in authors" v-if="author && nbItemsDisplayed < context.nbItemsDisplay && author.display
            && ++nbItemsDisplayed" :key="key + '-' + author.authorID" class="clearfix ">
              <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ author.authorID" aria-expanded="false" :aria-controls="'collapse-'+ author.authorID">
                <template v-if="authors[key].expertSource === 'TECHNICAL EDISON'">
                  <author-s-e-top v-model="authors[key]" class="" :context="context"/>
                </template>
                <author-top v-else v-model="authors[key]" class="" :context="context" :key="key + '-' + author.authorID + '-' + author.followSearchId"/>

                <div style="bottom: -9px;position: absolute;width: 100%">
                  <span style="margin-left: 49%;background-color: white;">
                    <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
                    <i class="fa fa-chevron-down"></i>
                    </button>
                  </span>
                </div>
              </div>

              <div class="col-xs-12 collapse" :id="'collapse-'+ author.authorID" style="padding: 20px" >
                <local-author-details v-model="authors[key].localExpert.expert" :author="author.localExpert"
                                      :pubDateSelected="context.pubDateSelected" :context="context" v-if="author.localExpert"/>

                <template v-if="authors[key].expertSource === 'TECHNICAL EDISON'">
                  <document-s-e-author v-model="authors[key].docs" :author="author"
                                       :pubDateSelected="context.pubDateSelected" :context="context"/>
                </template>
                <document-author v-else v-model="authors[key].docs" :author="author"
                                 :pubDateSelected="context.pubDateSelected" :context="context"/>
              </div>
            </div>
            <div v-if="localExperts && localExperts.length !== 0">
              <div v-for="(localExpert,key) in localExperts">
                <local-author-top v-model="localExperts[key]" :context="context" :key="key + '-' + localExpert.id"> </local-author-top>
                <div class="col-xs-12 collapse" :id="'collapse-'+ localExpert.id" style="padding: 20px;" >
                  <local-author-details v-model="localExperts[key].expert" :author="localExpert"
                                        :pubDateSelected="context.pubDateSelected" :context="context"/>
                </div>
                <div class="row" v-if="key === localExperts.length -1"> </div>
              </div>
            </div>

            <div class="text-center" style="padding: 25px" v-if="authors.length > context.nbItemsDisplay && !$user.isFreeTrial()">
              <button class="btn btn-primary btn-xs" :class="authors.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="authors.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
            <div class="text-center" style="padding: 25px" v-else-if="$user.isFreeTrial()">
              <router-link :to="{name: 'Register'}" class="btn btn-primary" >Signup for free to see more results</router-link>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="panel-body">
          <div class="text-center">
            <h2 class="m-b-xs">Whoops</h2>
            <div class="m">
              <i class="fa fa-exclamation-triangle fa-5x"></i>
            </div>
            <div class="text-left" style="display: inline-block;margin-top: 15px">
              <template v-if="context.filterSelected === 'newDocuments'">
                <h5 class="text-center" style="font-size:18px;">No new docs since last notification</h5>
                <h6 class="text-center">uncheck the 'new docs' filter to view full results or click the 'reset filters' button below</h6>
              </template>
              <template v-else>
                <h5 style="font-size:18px;">The combination of filters used has no result</h5>
                <h6 class="text-center">Reset some filters or click the 'reset filters' button below</h6>
              </template>
            </div>
            <div class="text-center" style="display: block;margin-top: 15px" >
              <button class="btn btn-info btn-sm" @click="resetFilters">Reset filters</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style>
.top-document {
  cursor: pointer;
  /*max-height: 80px;*/
  padding: 15px 0;
  border-bottom: 1px solid #eaeaea;
}
.top-document:hover {
  background: #f5f5f5;
}
</style>
<script>

import AuthorTop from './../documents/AuthorTop'
import LocalAuthorTop from './../documents/LocalAuthorTop'
import DocumentAuthor from '../documents/DocumentAuthor'
import AuthorSETop from '../documents/AuthorSETop'
import DocumentSEAuthor from '../documents/DocumentSEAuthor'
import LocalAuthorDetails from './../documents/LocalAuthorDetails'
import InternalAuthorTop from '../documents/InternalAuthorTop'
import InternalDocumentAuthor from '../documents/InternalDocumentAuthor'

export default {
  components: {
    InternalDocumentAuthor,
    InternalAuthorTop,
    DocumentSEAuthor,
    AuthorSETop,
    DocumentAuthor,
    AuthorTop,
    LocalAuthorTop,
    LocalAuthorDetails
  },
  props: ['context', 'value', 'listType', 'nbEstimateExperts', 'nbAuthors', 'changeSort', 'nbSearchCompanies',
    'resetFilters', 'localExperts'],
  name: 'SimpleListAuthorsResults',
  watch: {
    value: function (val) {
      this.authors = val
    }
  },
  data () {
    return {
      authors: null
    }
  },
  computed: {
    bestExperts: function () {
      let nbAuthorsNotDisplay = 0

      this.authors.forEach((author) => {
        nbAuthorsNotDisplay += (author.display === false) ? 1 : 0
      })

      let nb = this.nbAuthors - nbAuthorsNotDisplay
      return nb < 0 ? 0 : nb
    }
  },
  methods: {
    launchCompanySearch: function () {
      this.$eventHub.$emit('launchCompanySearch')
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })
  },
  beforeMount () {
    this.authors = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAuthors/SimpleListAuthorsResults.vue